import {BASE_ADMIN_API, fetchAPI} from '@/services/api';

// 银行字典 VO
export interface BankVO {
    id?: number;
    bankCode?: string;
    hkBankCode?: string;
    nameCn?: string;
    nameEn?: string;
    accountPattern?: string;
    enabled?: number;
    createTime?: string;
    updateTime?: string;
}

// 新增 BO
export interface BankCreateBO {
    bankCode: string;
    hkBankCode?: string;
    nameCn?: string;
    nameEn?: string;
    accountPattern?: string;
    enabled?: number;
}

// 更新 BO
export interface BankUpdateBO extends BankCreateBO {
    id: number;
}

// 分页响应（MyBatis-Plus Page）
export interface BankPage {
    records: BankVO[];
    total: number;
    size: number;
    current: number;
    pages: number;
}

const base = `${BASE_ADMIN_API}/bank`;

/** 分页列表，支持 keyword 模糊搜索 */
export async function getList(pageNum: number, pageSize: number, keyword?: string) {
    const params = new URLSearchParams({
        pageNum: String(pageNum),
        pageSize: String(pageSize),
    });
    if (keyword) params.set('keyword', keyword);
    return fetchAPI<BankPage>(`${base}/getList?${params.toString()}`, {method: 'GET'});
}

/** 按ID查询详情 */
export async function getById(id: number) {
    return fetchAPI<BankVO>(`${base}/getById/${id}`, {method: 'GET'});
}

/** 按 bankCode 查询 */
export async function getByCode(bankCode: string) {
    return fetchAPI<BankVO>(`${base}/getByCode/${encodeURIComponent(bankCode)}`, {method: 'GET'});
}

/** 新增 */
export async function create(bo: BankCreateBO) {
    return fetchAPI<number>(`${base}/create`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

/** 更新 */
export async function update(bo: BankUpdateBO) {
    return fetchAPI<boolean>(`${base}/update`, {
        method: 'PUT',
        body: JSON.stringify(bo),
    });
}

/** 删除 */
export async function deleteById(id: number) {
    return fetchAPI<boolean>(`${base}/deleteById/${id}`, {method: 'DELETE'});
}

export const BankService = {
    getList,
    getById,
    getByCode,
    create,
    update,
    deleteById,
};
